import EditorViewState from '../store/schema/EditorViewState';
import operateContentInternal from './ContentOperator';

export default function getScrollContainer(viewState: EditorViewState) {
    let result: HTMLElement;
    operateContentInternal(
        viewState,
        editor => {
            result = editor.getScrollContainer();
        },
        null /*PlainTextCallback*/
    );
    return result;
}
